import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function NavigationTabs({ activeTab, onTabChange }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    { id: "teachers", label: "Teachers" },
    { id: "schools", label: "Schools" },
    { id: "classes", label: "Classes" },
    { id: "roster", label: "Roster" },
    { id: "reporting-analytics", label: "Reporting & Analytics" },
    { id: "lti", label: "LTI Platforms" },
  ];

  // Read active tab from URL query param and respond to URL changes
  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (
      tabFromUrl &&
      tabs.some((tab) => tab.id === tabFromUrl) &&
      tabFromUrl !== activeTab
    ) {
      onTabChange(tabFromUrl);
    }
  }, [searchParams]);

  // Update URL when active tab changes
  const handleTabChange = (tabId) => {
    onTabChange(tabId);
    setSearchParams({ tab: tabId });
  };

  return (
    <div className="mb-5 border-b border-gray-200">
      {/* Dropdown for mobile */}
      <div className="lg:hidden">
        <select
          value={activeTab}
          onChange={(e) => handleTabChange(e.target.value)}
          className="block p-2 w-full rounded-md border-gray-300 text-sm shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>

      {/* Horizontal tabs for desktop */}
      <nav className="-mb-px hidden lg:flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? "border-[var(--color-headerActiveText)] font-bold text-[var(--color-headerActiveText)]"
                : "font-semibold border-transparent secondary-text hover:text-[var(--color-headerActiveText)] hover:border-[var(--color-headerActiveText)]"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
